import { apiParams, apiSlice } from '../../../store/Api';
import { DeliveryAddress } from '../../Profile/Types';
import { AggregatedOrders, Order } from '../Types';
import { Response } from '../../../core/Http/RestResponse';
import { QueryParams } from '../../../core/Http/QueryParams';
import { createHttpParams } from '../../../core/Http/HttpService';
import { OrderLine } from '../../Orders/Types';

const notDraftOrdersParams = { orderStatus: '!DRAFT' };

export const ordersApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getOrderItems: builder.query<Response<OrderLine[]>, { orderId: string; params?: QueryParams }>({
      query: ({ orderId, params }) => ({
        url: apiParams.paths.orderLines,
        params: { ...params, orderId },
      }),
    }),
    updateOrder: builder.mutation<Order, { orderId: string; deliveryAddress: DeliveryAddress }>({
      query: ({ orderId, deliveryAddress }) => ({
        url: `${apiParams.paths.orders}/${orderId}`,
        body: deliveryAddress,
        method: apiParams.methods.PATCH,
      }),
      invalidatesTags: [apiParams.tags.orders, apiParams.tags.shoppingCart],
    }),
    getOrders: builder.query<Response<Order[]>, { queryParams: QueryParams | void }>({
      query: ({ queryParams }) => ({
        url: apiParams.paths.orders,
        params: createHttpParams({ ...queryParams, params: notDraftOrdersParams }),
      }),
      providesTags: [apiParams.tags.orders],
    }),
    getOrdersAggregated: builder.query<AggregatedOrders, { aggregateBy: string }>({
      query: ({ aggregateBy }) => ({
        url: `${apiParams.paths.orders}/aggregate-by`,
        params: {
          aggregateBy,
          ...createHttpParams({ params: notDraftOrdersParams }),
        },
      }),
    }),
    getOrderDetails: builder.query<Order, { orderId: string }>({
      query: ({ orderId }) => ({
        url: `${apiParams.paths.orders}/${orderId}`,
      }),
      providesTags: [apiParams.tags.orderDetails],
    }),
    cancelOrder: builder.mutation<Order, { orderId: string }>({
      query: ({ orderId }) => ({
        url: `${apiParams.paths.orders}/${orderId}/cancel`,
        method: apiParams.methods.PATCH,
      }),
      invalidatesTags: [apiParams.tags.orderDetails],
    }),
  }),
});

export const {
  useCancelOrderMutation,
  useGetOrderDetailsQuery,
  useLazyGetOrderItemsQuery,
  useGetOrdersAggregatedQuery,
  useGetOrdersQuery,
  useLazyGetOrdersQuery,
  useUpdateOrderMutation,
} = ordersApiSlice;
